import React, { useEffect } from "react";
import FilesTemplate from "../../Templetes/Files/Files.template";

const FilesPage = () => {
  useEffect(() => {
    document.title = "International Robot Challenge - Files";
  }, []);
  return <FilesTemplate />;
};

export default FilesPage;
